import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

const CountdownTimer = ({ targetDate , isMobile }) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });

      if (distance < 0) {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [targetDate]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        fontSize :".7em",
        backgroundColor: "transparent",
        padding: "1em",
        borderRadius: "10px",
        color: "#FFFFFF",
        overflow: "hidden",
      }}
    >
      {Object.keys(timeLeft).map((key, index) => (
        <Box
          key={key}
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            margin: "0 1em",
          }}
        >
          <Box
            sx={{
              fontSize: "2.5em",
              fontWeight: "bold",
            }}
          >
            {String(timeLeft[key]).padStart(2, '0')}
          </Box>
          <Box
            sx={{
              fontSize: "1em",
              textTransform: "capitalize",
            }}
          >
            {key}
          </Box>
          {index < 3 && (
            <Box
              sx={{
                fontSize: "2.5em",
                margin: "0 0.5em",
              }}
            >
              :
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default CountdownTimer;
